import React, { useEffect, useRef, useState } from "react";
import NavigationDrawer from "./../../components/navigationDrawer/index";
import CustomBar from "../../components/customBar";
import AppContainer from "../../components/containers/AppContainer";
import { Divider, Box, Button } from "@mui/material";
import DynamicTable from "../../components/dynamicTable";
import { deleteFaq, getAllFaq } from "../../services/faq";
import CategoryButtons from "./faqButtons";
import AddDialog from "./add";
import AddIcon from "@mui/icons-material/Add";
import CustomSnackbar from "../../components/customSnackBar/customSnackBar";
import AppLoader from "../../components/loader/loader";

const selectInputWith = {
  width: { xs: "100%", md: "150px" },
};

const tableHeader = ["QUESTIONS", "ANSWERS", "ACTIONS"];

const displayRows = ["question", "answer", "actions_btn"];

const FAQ = () => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    question: "",
    answer: "",
  });
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [editData, setEditData] = useState(null);
  const snackRef = useRef();

  useEffect(() => {
    const savedCategory = localStorage.getItem("selectedCategory");
    if (savedCategory) {
      setSelectedCategory(JSON.parse(savedCategory));
    } else {
      const defaultCategory = { id: 1, name: "Customer FAQ", type: "customer" };
      setSelectedCategory(defaultCategory);
    }
  }, []);

  useEffect(() => {
    if (selectedCategory?.type) {
      fetchFaqData(selectedCategory.type);
      localStorage.setItem(
        "selectedCategory",
        JSON.stringify(selectedCategory)
      ); // Save to localStorage
    }
  }, [selectedCategory]);

  console.log(selectedCategory, "selectedCategory");
  const fetchFaqData = async (type) => {
    if (!type) return;

    setLoading(true);
    try {
      const response = await getAllFaq(type);
      setTableData(response?.data?.data || []);
    } catch (error) {
      console.error("Error fetching categories:", error);
      snackRef.current?.showMessage(error.message, "error");
      setTableData([]);
    } finally {
      setLoading(false);
    }
  };

  const handleCategorySelect = (category) => {
    setSelectedCategory(category);
  };

  const handleDialogClose = (submitted) => {
    if (submitted && selectedCategory?.type) {
      fetchFaqData(selectedCategory.type);
    }
    setFormData({ question: "", answer: "" }); // Reset form properly
    setDialogOpen(false);
    setEditData(null);
  };

  const openDialog = () => setDialogOpen(true);

  const handleEdit = (data) => {
    setEditData({
      _id: data._id,
      formData: {
        question: data.question,
        answer: data.answer,
      }
    });
    setFormData({
      question: data.question,
      answer: data.answer,
    });
    openDialog();
  };

  const handleDelete = async (id) => {
    setLoading(true);
    try {
      const response = await deleteFaq(id);
      if (response.data.status === "success") {
        snackRef.current?.isOpenSnack({
          snackType: "success",
          snackMessage: response.data.message,
        });
        fetchFaqData(selectedCategory?.type);
      } else {
        snackRef.current?.isOpenSnack({
          snackType: "error",
          snackMessage: response.data.message,
        });
      }
    } catch (error) {
      console.error("Error deleting FAQ:", error);
      snackRef.current?.showMessage("Failed to delete FAQ", "error");
    } finally {
      setLoading(false);
    }
  };
  return (
    <NavigationDrawer>
      {/* Mini Header */}
      <AppLoader isVisible={loading} />
      <CustomBar title={"FAQ"} />
      <CategoryButtons
        onCategorySelect={handleCategorySelect}
        selectedButton={selectedCategory?.id}
      />
      <Box display={"flex"} justifyContent={"flex-end"} mt={2} mb={2}>
        <Button
          onClick={openDialog}
          disabled={!selectedCategory}
          startIcon={<AddIcon />}
          sx={{
            px: 0,
            py: 0.5,
            fontWeight: "medium",
            fontSize: "16px",
            fontFamily: "Poppins",
            textTransform: "none",
            position: "relative",
            overflow: "hidden",
            width: "120px",
            backgroundColor: "primary.main",
            color: "#fff",
            borderRadius: "12px",
            border: "2px solid transparent",
            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
            transition: "transform 0.3s ease, box-shadow 0.3s ease",
            "&:hover": {
              transform: "scale(1.05)",
              backgroundColor: "primary.main",
              boxShadow: "0 12px 25px rgba(139, 69, 19, 0.6)",
            },
            "&::before": {
              content: '""',
              position: "absolute",
              top: "0",
              left: "0",
              background: "linear-gradient(45deg, #8B4513, #D2691E)",
              borderRadius: "inherit",
              transform: "scale(0)",
              transition: "transform 0.3s ease",
              zIndex: "-1",
            },
            "&:hover::before": {
              transform: "scale(1)",
            },
          }}
        >
          Add
        </Button>
      </Box>
      <AppContainer>
        <Divider />
        <DynamicTable
          tableHeader={tableHeader}
          displayRows={displayRows}
          tableData={tableData}
          showPagination={true}
          showUserMenu={true}
          handleEdit={handleEdit}
          handleDelete={(row) => handleDelete(row._id)}
        />
      </AppContainer>
      <AddDialog
        open={dialogOpen}
        onClose={handleDialogClose}
        setFormData={setFormData}
        formData={formData}
        title={selectedCategory?.name}
        type={selectedCategory?.type}
        editData={editData}
        fetchFaqData={fetchFaqData}
      />
      <CustomSnackbar ref={snackRef} />
    </NavigationDrawer>
  );
};

export default FAQ;
